export default __webpack_public_path__ + "static/media/logo.c91e8d10.png";